import react, { useEffect, useMemo, useState } from 'react';
import './formularios.scss'
import SidePanel from '../../../../../components/organismsv2/SidePanel/SidePanel';
import Button from '../../../../../components/Atomsv2/Button/Button';
import Card from '../../../../../components/Atomsv2/Card/Card';
import Table from '../../../../../components/moleculesv2/Table/Table';
import Column from '../../../../../components/moleculesv2/Table/Column';
import Modal from '../../../../../components/Atomsv2/Modal/Modal';
import Input from '../../../../../components/Atomsv2/Input/Input';
import { ToastContainer, useToast } from '../../../../../components/Atomsv2/Toast/Toast';
import Select from '../../../../../components/Atomsv2/Select/Select';
import Calendar from '../../../../../components/Atomsv2/Calendar/Calendar';
import { IntegracionProyectos } from '../../integracion';
import Status from '../../../../../components/Atomsv2/Status/Status';
import { convertirFormatoFecha, formateoBasico } from '../../../../../utilidades/formateos';
import MultiSelect from '../../../../../components/Atomsv2/MultiSelect/MultiSelect';

const Proyecto = ({ open, onClose, data, setData }) => {
    const { toasts, addToast, removeToast } = useToast();

    const [openAddModal, setOpenAddModal] = useState(false);
    const [addData, setAddData] = useState({
        proyecto: '',
        descripcion: '',
        area: null,
        prioridad: null,
        estatus: null,
        fecha_ini: null,
        fecha_fin: null
    });
    const [filtros, setFiltros] = useState({
        estatus: data.estatus || [],
        area: data.area || [],
        prioridades: data.prioridades || [],
    })
    const areas = useMemo(() => data.area.map((area) => ({ value: area.ID, label: area.AREA })), [data.area]);
    const prioridades = useMemo(() => data.prioridades.map((prioridad) => ({ value: prioridad.ID, label: prioridad.PRIORIDAD })), [data.prioridades]);
    const estatusSelect = useMemo(() => data.estatus.map((estatu) => ({ value: estatu.ID, label: estatu.ESTATUS })), [data.estatus]);

    useEffect(() => {
        setFiltros({
            estatus: data.estatus || [],
            area: data.area || [],
            prioridades: data.prioridades || [],
        });
    }, [data.area, data.estatus, data.prioridades]);

    const getId = (item) => item?.ID ?? item?.value;

    const proyectosFiltrados = useMemo(() => {
        const idsArea = filtros.area.map(getId);
        const idsPrioridad = filtros.prioridades.map(getId);
        const idsEstatus = filtros.estatus.map(getId);

        return data.proyecto.filter((proy) =>
            idsArea.includes(proy.ID_AREA) &&
            idsPrioridad.includes(proy.ID_PRIORIDAD) &&
            idsEstatus.includes(proy.ID_ESTATUS)
        );
    }, [data.proyecto, filtros]);
    const submit = async () => {
        try {
            if (!addData.proyecto || !addData.descripcion || !addData.area || !addData.prioridad || !addData.estatus || !addData.fecha_ini || !addData.fecha_fin) {
                addToast("Por favor, complete todos los campos", "error", 3000, 'ligth');
                return;
            }
            setData(prev => ({
                ...prev,
                proyecto: [...prev.proyecto, {
                    ID: prev.proyecto.length + 1,
                    PROYECTO: addData.proyecto,
                    DESCRIPCION: addData.descripcion,
                    AREA: addData.area.label,
                    ID_AREA: addData.area.value,
                    PRIORIDAD: addData.prioridad.label,
                    ID_PRIORIDAD: addData.prioridad.value,
                    ESTATUS: addData.estatus.label,
                    ID_ESTATUS: addData.estatus.value,
                    FECHA_INI: addData.fecha_ini,
                    FECHA_FIN: addData.fecha_fin
                }]
            }));
            setAddData(false);
            const dataToSend = {
                proyecto: addData.proyecto,
                descripcion: addData.descripcion,
                area_id: addData.area.value,
                prioridad_id: addData.prioridad.value,
                estatus_id: addData.estatus.value,
                fecha_ini: addData.fecha_ini,
                fecha_fin: addData.fecha_fin
            };
            await IntegracionProyectos.createProyecto(dataToSend);
            setOpenAddModal(false);
            addToast("Proyecto agregado exitosamente", "success", 3000, 'ligth');
        }
        catch (error) {
            console.error("Error al agregar el proyecto:", error);
            addToast("Error al agregar el proyecto", "error", 3000, 'ligth');
        }
    }
    //   tabla
    const handleRowEdit = (newRow, rowIndex) => {
        try {
            setData(prev => ({
                ...prev,
                proyecto: prev.proyecto.map((item, index) => index === rowIndex ? newRow : item)
            }));
            IntegracionProyectos.updateProyecto({
                id: newRow.ID,
                proyecto: newRow.PROYECTO,
                descripcion: newRow.DESCRIPCION,
                area_id: newRow.ID_AREA,
                prioridad_id: newRow.ID_PRIORIDAD,
                estatus_id: newRow.ID_ESTATUS,
                fecha_ini: newRow.FECHA_INI,
                fecha_fin: newRow.FECHA_FIN
            });
        }
        catch (error) {
            console.error("Error al actualizar el proyecto:", error);
            addToast("error en la edición", "error", 3000, 'ligth');
        }
    };
    const statusTemplate = (id_estatus, estatus) => {
        const colores = {
            1: 'default',
            2: 'warning',
            3: 'primary',
            4: 'neutral',
            5: 'success',
            6: 'error',
        }
        const color = colores[id_estatus] || '#6c757d';
        return (
            <Status severity={color} >{estatus}</Status>
        )
    }
    const prioridadTemplate = (id_prioridad, prioridad) => {
        const colores = {
            3: 'success',
            2: 'warning',
            1: 'error',
        }
        const color = colores[id_prioridad] || '#6c757d';
        return (
            <Status severity={color} >{prioridad}</Status>
        )
    }
    function formatearFecha(fecha) {
        const [fechaParte, horaParte] = fecha.split(' ');
        const [yyyy, MM, dd] = fechaParte.split('-');
        const [HH, mm] = horaParte.split(':');

        return `${dd}/${MM}/${yyyy} ${HH}:${mm}`;
    }
    const header = (<div className='header-proyecto-TABLA'>
        <MultiSelect
            label={"Area"}
            placeholder='Filtro por AREA'
            options={data.area}
            value={filtros.area}
            onChange={(e) => { setFiltros(prev => ({ ...prev, area: prev.area = e })) }}
            mapper={{ name: "AREA", value: "ID" }}
        />
        <MultiSelect
            placeholder='Filtro por PRIORIDAD'
            label={"Prioridad"}

            options={data.prioridades}
            value={filtros.prioridades}
            onChange={(e) => { setFiltros(prev => ({ ...prev, prioridades: prev.prioridades = e })) }}
            mapper={{ name: "PRIORIDAD", value: "ID" }}
        />
        <MultiSelect
            placeholder='Filtro por ESTATUS'
            label={"Estatus"}

            options={data.estatus}
            value={filtros.estatus}
            onChange={(e) => { setFiltros(prev => ({ ...prev, estatus: prev.estatus = e })) }}
            mapper={{ name: "ESTATUS", value: "ID" }}
        />
    </div>)
    return (
        <SidePanel
            open={open}
            onClose={onClose}
            width="80vw"
            title="Proyecto"
            icon="folder"
            subtitle={'Crea o edita un proyecto para organizar tus tareas'}
        >
            <div className='header-proyecto-general'>
                <Button icon={"add"} onClick={() => { setOpenAddModal(true) }}></Button>
            </div>

            <Card>
                <Table
                    labelBuscador={"Proyecto"}
                    data={proyectosFiltrados}
                    height='calc(100vh - 270px)'
                    globalFilter
                    onRowEdit={handleRowEdit}
                    responsiveHideColumn
                    header={header}
                >
                    <Column
                        header="ID"
                        value="ID"
                        sortable
                    />
                    <Column
                        header="PROYECTO"
                        value="PROYECTO"
                        edit="text"
                        sortable
                    />
                    <Column
                        header="DESCRIPCION"
                        value="DESCRIPCION"
                        edit="text"
                        sortable
                    />
                    <Column
                        header="AREA"
                        value="ID_AREA"
                        editLabelKey="AREA"
                        edit="select"
                        body={(row) => row.AREA}
                        editOptions={areas}
                        sortable
                    />
                    <Column
                        header="PRIORIDAD"
                        value="ID_PRIORIDAD"
                        editLabelKey="PRIORIDAD"
                        edit="select"
                        body={(row) => prioridadTemplate(row.ID_PRIORIDAD, row.PRIORIDAD)}
                        editOptions={prioridades}
                        sortable
                    />
                    <Column
                        header="ESTATUS"
                        value="ID_ESTATUS"
                        editLabelKey="ESTATUS"
                        edit="select"
                        body={(row) => statusTemplate(row.ID_ESTATUS, row.ESTATUS)}
                        editOptions={estatusSelect}
                        sortable
                    />
                    <Column
                        header="FECHA INICIO"
                        value="FECHA_INI"
                        edit="datetime"
                        body={(row) => formatearFecha(row.FECHA_INI)}
                        sortable

                    />
                    <Column
                        header="FECHA FIN"
                        value="FECHA_FIN"
                        edit="datetime"
                        body={(row) => formatearFecha(row.FECHA_FIN)}
                        sortable
                    />
                </Table>
            </Card>

            {
                openAddModal == true && (
                    <Modal className='modalProyectoGeneralAgreagr' style={{ zIndex: "1201" }} onClose={() => setOpenAddModal(false)} title="Agregar Proyecto">
                        <div className='modal-content-general-proyectos'>
                            <Input label={"PROYECTO"} icon={'folder_open'} value={addData.proyecto} onChange={(e) => { setAddData(prev => ({ ...prev, proyecto: prev.proyecto = e.target.value })) }}></Input>
                            <Input label={"DESCRIPCIÓN"} icon={'description'} value={addData.descripcion} onChange={(e) => { setAddData(prev => ({ ...prev, descripcion: prev.descripcion = e.target.value })) }}></Input>
                            <div className='input-container'>
                                <Calendar withTime label={"FECHA INICIO"} icon={'calendar_month'} value={addData.fecha_ini} onChange={(e) => { setAddData(prev => ({ ...prev, fecha_ini: prev.fecha_ini = e })) }}></Calendar>
                                <Calendar withTime label={"FECHA FIN"} icon={'calendar_month'} value={addData.fecha_fin} onChange={(e) => { setAddData(prev => ({ ...prev, fecha_fin: prev.fecha_fin = e })) }}></Calendar>

                            </div>
                            <Select label={"AREA"}
                                icon={'crop_square'}
                                value={addData.area}
                                onChange={(e) => { setAddData(prev => ({ ...prev, area: e })) }}
                                options={areas}
                                mapper={{ name: 'label', value: 'value' }}
                            >
                            </Select>
                            <div className='input-container'>
                                <Select label={"PRIORIDAD"}
                                    icon={'priority'}
                                    value={addData.prioridad}
                                    onChange={(e) => { setAddData(prev => ({ ...prev, prioridad: e })) }}
                                    options={prioridades}
                                    mapper={{ name: 'label', value: 'value' }}
                                >
                                </Select>
                                <Select label={"ESTATUS"}
                                    icon={'incomplete_circle'}
                                    value={addData.estatus}
                                    onChange={(e) => { setAddData(prev => ({ ...prev, estatus: e })) }}
                                    options={estatusSelect}
                                    mapper={{ name: 'label', value: 'value' }}
                                >
                                </Select>
                            </div>

                            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px" }}>
                                <Button icon='save' onClick={() => { submit() }}>Guardar</Button>
                            </div>
                        </div>
                    </Modal>
                )
            }

            <ToastContainer toasts={toasts} removeToast={removeToast} />
        </SidePanel>
    )
}
export default Proyecto